<template>
    <div class="pt-10 px-2">
        <div class="flex border border-white text-white text-md">
            <div class="w-3/12 flex justify-center items-center bg-white">
                <icon name="alert-warning" class="w-10 h-10 fill-gray-700"/>
            </div>
            <div class="w-9/12 px-2 py-2">{{$t('shared.beta')}}</div>
        </div>
    </div>
</template>

<script>

import Icon from '@/Shared/Icon';

export default {
    components: {
        Icon
    }
}
</script>
